// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18-hS","type":"styles_type__3yAvp","choices":"styles_choices__2dh4K"};